import ACTIONS from "../../constants/actions";

const initialState = {
	collation : [],
	events    : [],
	leagues   : [],
	sports    : [],
	fetching  : true,
};

export default function mainLiveSoon(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.MAIN_LIVE_SOON.RECEIVE_PROPS: {
			const newState = {
				...action.data,
				fetching : false
			};

			return Object.assign({}, {...state, ...newState});
		}
		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/live-soon.js